import { render, staticRenderFns } from "./PlayerMainArtworkMeta.vue?vue&type=template&id=713b49a6&scoped=true&"
import script from "./PlayerMainArtworkMeta.vue?vue&type=script&lang=js&"
export * from "./PlayerMainArtworkMeta.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMainArtworkMeta.vue?vue&type=style&index=0&id=713b49a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b49a6",
  null
  
)

component.options.__file = "PlayerMainArtworkMeta.vue"
export default component.exports